export class ActionItemConfigResultDto {
  item: string;
  title: string;
  enable: boolean;
}
